<template>
<div style="display: none">{{ setData() }}</div>
<MDBModalHeader>
    <MDBModalTitle id="printDesignModalLabel" :style="{ width: '100%' }">
        <div style="display: flex; gap: 15px;">
            <div style="display: flex; gap: 15px;">
                <div class="buy-btn" title="Download dst" style="display: grid; justify-items: center; width: 100px;">
                    <span style="font-size: 13px;"> Download dst </span>
                    <MDBBtn>
                        <icon-svg :height="20" :width="20" icon="ic:round-file-download" @click="downloadDstDesign(imageToPreview, item.lineIndex)" />
                    </MDBBtn>
                </div>
                <div class="change-btn" title="Change Design" style="display: grid; justify-items: center; width: 100px;">
                    <span style="font-size: 13px;"> Change Design </span>
                    <MDBBtn>
                        <icon-svg :height="20" :width="20" icon="streamline:interface-edit-write-2-change-document-edit-modify-paper-pencil-write-writing" @click="openDesignPopup()" />
                    </MDBBtn>
                </div>
                <!-- {{ this.designsObj}} -->
                <!-- {{ Object.values(this.designsObj[this.imageToPreview].userArts).length }} -->
                <div v-if="this.designsObj[
                this.imageToPreview
              ].userArts != null && Object.values(this.designsObj[this.imageToPreview].userArts).length > 0" class="change-btn" title="Change Design" style="display: grid; justify-items: center; width: 100px;">
                    <span style="font-size: 13px;"> See original design </span>
                    <MDBBtn>
                        <icon-svg :height="20" :width="20" icon="streamline:interface-edit-write-2-change-document-edit-modify-paper-pencil-write-writing" @click="seeOriginalDesign = !seeOriginalDesign" />
                    </MDBBtn>
                </div>
            </div>
            <div style="width: 100%; display: block">
                <h5 class="modal-title" :style="{ 'justify-content': 'center' }">
                    <b>Print {{ product.productName }} </b>
                </h5>
                <h6 class="modal-title" :style="{ 'justify-content': 'center' }">
                    Variant: {{ product.variants[variantID].variantName }}
                </h6>
                <h6 class="modal-title" :style="{ 'justify-content': 'center' }">
                    Product type: {{ item.productType }}
                </h6>
                <h6 class="modal-title" :style="{ 'justify-content': 'center' }">
                    Orderate quantity: {{ item.quantity }}
                </h6>
            </div>
        </div>
    </MDBModalTitle>
    <!-- {{ designFromStore.imgVariants[this.imageToPreview].userArts }} -->
    <DesignScreen :_productId="product.productID" :_variantId="variantID" :_designObj="designFromStore" :_imgToPreview="imageName" :onManagerUpdateDesign="onDesignUpdated"></DesignScreen>
</MDBModalHeader>
<MDBModalBody style="overflow-y: auto">
    <div class="contain-order">
        <div class="left-preview">
            <template v-if="seeOriginalDesign == true">
                <DesignScreen :_productId="product.productID" :_variantId="variantID" :_designObj="originalDesign" :_imgToPreview="imageName"></DesignScreen>
            </template>
            <table v-if="seeOriginalDesign == false" class="table responsive-table">
                <thead>
                    <tr>
                        <th>colorID</th>
                        <th>hex color</th>
                        <th>color name</th>
                        <th>color</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(colorObj, index) in this.store.getColorsList(
                product.productID,
                variantID,
                this.imageToPreview,
                this.designsObj
              ).colorsList" :key="index">
                        <td>{{ colorObj.colorID }}</td>
                        <td>{{ colorObj.hexColor }}</td>
                        <td>{{ colorObj.colorName }}</td>
                        <td>
                            <div class="dd-color">
                                <span :style="{
                      backgroundColor: store.allColors.value[colorObj.colorID].color,
                    }">
                                </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-else>

            </div>
        </div>
        {{ store.currentEditingProps.dpi }}
        <div class="emb-order">
            <div class="product-images" style="display: flex; justify-content: center; margin-bottom: 15px">
                <div v-for="(image, index) in this.store.getAllImagesFromList(this.product.productID, this.variantID, Object.keys(designsObj), this.imageToPreview)" :key="index" :class="(imagesNames.find(f => f == image.imageName) != null) ?
                          'bg-image hover-zoom downloadImg' : 'bg-image hover-zoom notDownloadImg'" @click.stop="changeImgToPrint(image)" :title="image.imageName" style="
              height: 15vh;
              position: relative;
              width: 15vh;
              margin: 2px;
              display: flex;
              justify-content: center;
              align-items: center;
            ">
                    <img ref="embCanvas" style="
                position: absolute;
                padding: 5px;
                max-width: 100%;
                max-height: 100%;
                align-items: center;
              " :src="image.file.relativePath.replaceAll('\\', '\\\\')" hover-overlay hover-zoom hover-shadow />
                </div>
            </div>
            <div ref="embCanvasCurrent" class="emb-canvas" :style="{
            'background-image': getImgPath(getCurrentProduct()),
            position: 'relative',
          }">
                <!-- {{ this.designsObj[
                this.imageToPreview
              ].userArts }} -->
                <div :style="{
                          transform: 'translate(' + getCurrentProduct().box.topLeftDmm.x *
                            (store.currentEditingProps.dpi / 254.0) +
                          'px,' + getCurrentProduct().box.topLeftDmm.y *
                            (store.currentEditingProps.dpi / 254.0) +
                          'px)',
              height: getCurrentProduct().box.heightInches * store.currentEditingProps.dpi + 'px',
              width: getCurrentProduct().box.widthInches * store.currentEditingProps.dpi + 'px',
              borderColor: 'yellow',
              borderStyle: 'dashed',
              position: 'absolute',
            }">
                    <div v-for="(userArtObjectToShow, index) in this.designsObj[this.imageToPreview].userArts" :key="index" :style="{
    transform: transformFromDrag(userArtObjectToShow),
    width: sizeFromDrag(userArtObjectToShow.dragTransform.width, userArtObjectToShow.dragTransform.dpi),
    height: sizeFromDrag(userArtObjectToShow.dragTransform.height, userArtObjectToShow.dragTransform.dpi),
    position: 'absolute'
  }">
                          <!-- {{ store.allUserArts.value[userArtObjectToShow.userUploadedArtID]?.dstSizesJson && Object.values(this.store.allUserArts.value[4]?.dstSizesJson).length == 0 }} -->
                        <div v-if="store.allUserArts.value[userArtObjectToShow.userUploadedArtID]?.dstSizesJson && Object.values(this.store.allUserArts.value[4]?.dstSizesJson).length > 0" ref="userArtsElementsRefs" :id="`target_user_art_${index}`" class="ele-container">
                          
                          <!-- <DSTPreview :style="{
      left: `${((userArtObjectToShow.location.x - userArtObjectToShow.dragLocation.x) * store.currentEditingProps.dpi) / 254.0}px`,
      top: `${((userArtObjectToShow.location.y - userArtObjectToShow.dragLocation.y) * store.currentEditingProps.dpi) / 254.0}px`
    }" :dwidth="(store.allUserArts.value[userArtObjectToShow.userUploadedArtID]?.dstSizesJson?.sizes.pixelWidth * store.currentEditingProps.dpi) / 254.0" :dheight="(store.allUserArts.value[userArtObjectToShow.userUploadedArtID]?.dstSizesJson?.sizes.pixelHeight * store.currentEditingProps.dpi) / 254.0" :dstFile="store.allUserArts.value[userArtObjectToShow.userUploadedArtID]?.dstSizesJson?.sizes.dstfile" :layersColors="store.allUserArts.value[userArtObjectToShow.userUploadedArtID]?.dstSizesJson?.sizes.colors" left="0" top="0" :arc="parseFloat(userArtObjectToShow.artArc)" /> -->

                          <!-- <img v-if="userArtObjectToShow.userUploadedArtID != undefined" :width="`${(store.allUserArts.value[userArtObjectToShow.userUploadedArtID].pixelWidth *
        store.currentEditingProps.dpi) / 254.0}px`" :height="`${(store.allUserArts.value[userArtObjectToShow.userUploadedArtID].pixelHeight *
        store.currentEditingProps.dpi) / 254.0}px`" :style="transformFromDrag(userArtObjectToShow)" :src="`${store.baseURL}/${store.allUserArts.value[userArtObjectToShow.userUploadedArtID].relativePath}_original.png`" /> -->

</div>
                    </div>

                    <div v-for="(artObjectToShow, index) in this.designsObj[this.imageToPreview].arts" :key="index" :style="{
    transform: transformFromDrag(artObjectToShow),
    width: sizeFromDrag(artObjectToShow.dragTransform.width, artObjectToShow.dragTransform.dpi),
    height: sizeFromDrag(artObjectToShow.dragTransform.height, artObjectToShow.dragTransform.dpi),
    position: 'absolute'
  }">
                        <DSTPreview :style="{
      left: `${((artObjectToShow.location.x - artObjectToShow.dragLocation.x) * store.currentEditingProps.dpi) / 254.0}px`,
      top: `${((artObjectToShow.location.y - artObjectToShow.dragLocation.y) * store.currentEditingProps.dpi) / 254.0}px`
    }" :dwidth="(store.allArts.value[artObjectToShow.artID].sizes[artObjectToShow.artSizeID].dstfile.pixelWidth * store.currentEditingProps.dpi) / 254.0" :dheight="(store.allArts.value[artObjectToShow.artID].sizes[artObjectToShow.artSizeID].dstfile.pixelHeight * store.currentEditingProps.dpi) / 254.0" :dstFile="store.allArts.value[artObjectToShow.artID].sizes[artObjectToShow.artSizeID].dstfile" :layersColors="artObjectToShow.colors" left="0" top="0" :arc="parseFloat(artObjectToShow.artArc)" />
                    </div>

                    <div v-for="(textObjectToShow, index) in this.designsObj[this.imageToPreview].texts" :key="index" :style="{
    width: sizeFromDrag(textObjectToShow.dragTransform.width, textObjectToShow.dragTransform.dpi),
    height: sizeFromDrag(textObjectToShow.dragTransform.height, textObjectToShow.dragTransform.dpi),
    transform: transformFromDrag(textObjectToShow),
    position: 'absolute'
  }">
                        <TextPreview v-if="textObjectToShow.text != ''" :IDFontToPreview="textObjectToShow.fontID" :IDSizeFontToPreview="textObjectToShow.fontSizeID" :TextToPreview="textObjectToShow.text" :dpi="store.currentEditingProps.dpi" superPos="normal" :layersColors="textObjectToShow.layersColors" :x="0" :y="0" :arc="textObjectToShow.textArc" :inDesign="true" />
                    </div>

                    <div v-for="(monogramObjectToShow, index) in this.designsObj[this.imageToPreview].monograms" :key="index" :style="{
    width: sizeFromDrag(monogramObjectToShow.dragTransform.width, monogramObjectToShow.dragTransform.dpi),
    height: sizeFromDrag(monogramObjectToShow.dragTransform.height, monogramObjectToShow.dragTransform.dpi),
    transform: transformFromDrag(monogramObjectToShow),
    position: 'absolute'
  }">
                        <MonogramPreview :monogramObj="store.allMonograms.value[monogramObjectToShow.monogramID]" :colorLeftChar="monogramObjectToShow.colorsLeftChar" :colorMiddleChar="monogramObjectToShow.colorsMiddleChar" :colorRightChar="monogramObjectToShow.colorsRightChar" :char1="monogramObjectToShow.leftChar" :char2="monogramObjectToShow.middleChar" :char3="monogramObjectToShow.rightChar" :align="monogramObjectToShow.align" :distance1="monogramObjectToShow.distance1" :distance2="monogramObjectToShow.distance2" :dpi="store.currentEditingProps.dpi" />
                    </div>

                </div>
            </div>
        </div>
    </div>
</MDBModalBody>
</template>

<script>
import {
    designerStore
} from "@/stores/designerStore";
import {
    nextTick
} from "vue-demi";
// import ProductDesign from "./ProductDesign.vue";
import TextPreview from "./TextPreview.vue";
import DSTPreview from "./DSTPreview.vue";
import MonogramPreview from "./MonogramPreview.vue";
import {
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBBtn,
} from "mdb-vue-ui-kit";
import DesignScreen from "./DesignScreen.vue";

export default {
    setup() {
        const store = designerStore();
        return {
            store,
        };
    },
    components: {
        DesignScreen,
        // ProductDesign,
        TextPreview,
        DSTPreview,
        MonogramPreview,
        MDBModalHeader,
        MDBModalTitle,
        MDBModalBody,
        MDBBtn,
    },
    data() {
        return {
            imageToPreview: null,
            // dpi: 254.0,
            designsObj: null,
            originalDesign: null,
            inProcessDpi: false,
            loadingComponent: true,
            dstDownloadFilesList: null,
            openChangeDesignPopup: false,
            seeOriginalDesign: false,
        };
    },
    props: ["product", "variantID", "imageName", "item", "designFromStore", "orderNumber", "imagesNames", "cartLineIndex", "dstDownloadFiles"],
    async mounted() {
        window.addEventListener("resize", this.eventHandler);
    },
    async beforeUnmount() {
        window.removeEventListener("resize", this.eventHandler);
    },
    methods: {
        openDesignPopup() {
            document.getElementById("btn-insertDesignsToVariantProductChangeDesign").click();
        },
        async setData() {
            if (!this.loadingComponent) return;
            this.imageToPreview = this.imageName;
            this.dstDownloadFilesList = this.dstDownloadFiles;
            // this.designsObj = JSON.parse(this.item.embDesign).imgVariants;
            this.designsObj = this.designFromStore.imgVariants;
            this.originalDesign = JSON.parse(JSON.stringify(this.designsObj));

            var imageToPreviewObj = Object.values(this.store.allProducts[this.product.productID]?.variants[this.variantID]?.images).filter(image => image.isUseful == true);

            this.store.currentEditingProps.isDesignDst = imageToPreviewObj.productType == 'Embroidery' || imageToPreviewObj.productType == undefined ? true : false;
            this.store.currentEditingProps.productType = imageToPreviewObj.productType == undefined ? 'Embroidery' : imageToPreviewObj.productType; //"WoodEngrave", //GlassEngrave //Embroidery //ColorSticker

            // this.dpi = 19;
            await this.calculateDpi();
            this.loadingComponent = false;
        },
        getImgPath(image) {
            return "url(" + image.file.relativePath.replaceAll("\\", "\\\\") + ")";
        },
        getCurrentProduct() {
            return this.store.allProducts[this.product.productID].variants[this.variantID].images[
                this.imageToPreview];
        },
        async calculateDpi() {
            await nextTick();
            const imgSizeFromHtml =
                this.$refs.embCanvasCurrent.getBoundingClientRect();
            var imgRatioFromHtml = imgSizeFromHtml.width / imgSizeFromHtml.height;
            var imgRatio =
                this.getCurrentProduct().imgWidthInches /
                this.getCurrentProduct().imgHeightInches;
            var width =
                imgRatio < imgRatioFromHtml ?
                this.getCurrentProduct().imgWidthInches *
                (imgSizeFromHtml.height / this.getCurrentProduct().imgHeightInches) :
                imgSizeFromHtml.width;

            this.store.currentEditingProps.dpi = width / this.getCurrentProduct().imgWidthInches;
        },
        async eventHandler() {
            console.log("eventHandler function open");
            await this.calculateDpi();
        },
        async changeImgToPrint(image) {
            this.imageToPreview = image.imageName;
            await this.calculateDpi();
        },
        async downloadDstDesign(imageName) {
            await this.store.downloadDstDesign(
                this.product.productID,
                this.variantID,
                imageName,
                this.designsObj,
                this.orderNumber,
                this.cartLineIndex
            );
            await eval("reloadPage()");
            //this.dstDownloadFilesList = await this.store.getDstDownloadFiles();
        },
        async onDesignUpdated(design) {
            await this.store.manageUpdateUserDesign(
                this.orderNumber,
                this.cartLineIndex,
                design
            );
            this.designsObj[this.imageToPreview] = design.imgVariants[this.imageToPreview];

        },

        dpiFactor(dpiFrom) {
            return this.store.currentEditingProps.dpi / dpiFrom;
        },
        scaleDrag(value, dpiFrom) {
            return value * this.dpiFactor(dpiFrom);
        },
        transformFromDrag(obj) {
            const factor = this.dpiFactor(obj.dragTransform.dpi);
            const x = obj.dragTransform.x * factor;
            const y = obj.dragTransform.y * factor;
            const scaleX = obj.dragTransform.scale.scaleX;// * factor;
            const scaleY = obj.dragTransform.scale.scaleY;// * factor;
            return `translate(${x}px, ${y}px) scale(${scaleX}, ${scaleY}) rotate(${obj.dragTransform.rotate}deg)`;
        },
        sizeFromDrag(value, dpiFrom) {
            return `${value * this.dpiFactor(dpiFrom)}px`;
        }
    },
};
</script>

<style scoped>
.vue-select {
    width: 100%;
}

.contain-order {
    flex-direction: row;
    width: 100%;
    display: flex;
    height: 75vh;
}

.emb-order {
    order: 1;
    width: 60%;
    margin-left: auto;
}

.dd-color>span {
    height: 20px;
    width: 20px;
    border-radius: 10px;
    display: inline-block;
}

.left-preview {
    width: 40%;
}

.print-btn :hover {
    background-color: aliceblue;
}

@media only screen and (max-width: 768px) {
    .contain-order {
        flex-direction: column;
    }

    .left-preview {
        width: 100%;
        order: 2;
    }

    .emb-order {
        order: 1;
        width: 100%;
    }

    .product-images {
        justify-content: center !important;
    }
}
</style><style>
.form-outline.form-control {
    margin: 5px;
}

.row.vue-select {
    margin: 5px;
}
</style>
